import type { GRID } from 'vars/index'
import type { IGridProps } from './Grid'
import type { GridColumnGaps, GridRowGaps } from './Grid.h'

import { styled } from '@linaria/react'
import { TextBoxSC } from 'atoms/TextBox'
import { CARDS_ASPECT_RATIO } from 'blocks/Cards/Card.h'
import { CardsContainerSC } from 'blocks/Grid/components/CardsContainer.styled'
import { FIXED_INDENTS } from 'vars/fixed-indents'
import { LAYOUT } from 'vars/index'

export const GridWrapper = styled.div<
  Omit<
    IGridProps,
    'content' | 'itemCount' | 'render' | 'onLoadMoreItems' | 'hasNextPage'
  >
>`
  position: relative;
  width: 100%;
  padding: ${({ paddings }) =>
    paddings?.length
      ? paddings.map((padding) => `var(${padding})`).join(' ')
      : 0};
  display: flex;
  flex-direction: column;
  background-color: ${({ backgroundColor }) =>
    backgroundColor ? `var(${backgroundColor})` : 'unset'};

  & > ${TextBoxSC} {
    margin: ${({ marginTitle }) =>
      marginTitle?.length
        ? marginTitle.map((margin) => `var(${margin})`).join(' ')
        : 0};
  }
  margin-top: ${({ verticalTopOffset = FIXED_INDENTS.INDENT_0 }) =>
    `var(${verticalTopOffset})`};
`
export const GridSC = styled.div<{
  cardsCount: number
  rowGap?: (typeof GridRowGaps)[keyof typeof GridRowGaps]
  columnGap?: (typeof GridColumnGaps)[keyof typeof GridColumnGaps]
  aspectRatio: (typeof CARDS_ASPECT_RATIO)[keyof typeof CARDS_ASPECT_RATIO]
  horizontalPaddings?: LAYOUT | GRID
}>`
  --horizontalGap: ${({ columnGap }) => `var(${columnGap})`};
  --verticalGap: ${({ rowGap }) => `var(${rowGap})`};
  --gridHorizontalPaddings: ${({
    horizontalPaddings = LAYOUT.HorizontalPaddings,
  }) => `var(${horizontalPaddings})`};

  --cardsCount: ${({ cardsCount }) => cardsCount};
  --aspectRatio: ${({ aspectRatio }) =>
    aspectRatio || CARDS_ASPECT_RATIO.TV_SHOW_EPISODE_POSTER_DEFAULT};

  & > ${CardsContainerSC} {
    //could be problems when grid's width !== 100%
    --cardWidth: calc(
      (
          100vw - var(--gridHorizontalPaddings) * 2 - (var(--cardsCount) - 1) *
            var(--horizontalGap)
        ) /
        var(--cardsCount)
    );

    display: grid;
    grid-template-columns: repeat(var(--cardsCount), var(--cardWidth));
    grid-template-rows: auto;
    gap: var(--verticalGap) var(--horizontalGap);
  }
`

// FP-4238: Show More / Show Less toggle under a collapsible search section grid
export const GridCollapseToggleSC = styled.div`
  display: flex;
  justify-content: flex-end;
  width: 100%;
  margin-top: var(${FIXED_INDENTS.INDENT_40});
`
